import { Box, Grid, ListItemText, ListItemButton } from '@mui/material';
import { Fragment } from 'react';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import { mesesEnum } from '../constants';
import { getLastYearsList } from '../../../utils/helpers';
import { estados } from '../constants/estados';

export const MisVisitasFilters = ({
    delegaciones = [],
    pacientes = [],
    filters,
    handleChangeFilters,
}) => {

    const renderOption = (props, option) => {
        return (
            <li {...props} key={option.idPaciente} style={{ padding: 0 }}>
                <ListItemButton sx={{ py: 0.3, px: 1, minHeight: 0 }}>
                    <ListItemText
                        primary={`${option.apellido}, ${option.nombre}`}
                        secondary={[
                            `HC: ${option.id}`,
                            option.numeroDocumento ? `DNI: ${option.numeroDocumento}` : null,
                        ]
                            .filter(Boolean)
                            .join(' • ')}
                    />
                </ListItemButton>
            </li>
        );
    }

    const filterOptions = (options, { inputValue }) => {
        const query = inputValue.toLowerCase();

        return options.filter((opt) => {
            const labelMatch = opt.label?.toLowerCase().includes(query);
            const docMatch = opt.numeroDocumento?.toString().toLowerCase().includes(query);

            return labelMatch || docMatch;
        });
    }

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{ marginBottom: '25px' }}
            >
                <Grid size={12}>
                    <RenderInputByTypeMobile
                        input={{
                            type: 'multiple_boolean',
                            name: 'tipoVisita',
                            options: [{ label: 'Tareas', value: 1 }, { label: 'Pacientes', value: 2 }]
                        }}
                        row
                        value={filters.tipoVisita}
                        handleChange={handleChangeFilters}
                    />
                </Grid>
                {filters?.tipoVisita == 2 && (
                    <Fragment>
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'select',
                                    displayName: 'Delegación',
                                    name: 'idDelegacion',
                                    options: delegaciones,
                                    key: `${filters?.idDelegacion}-delegacion`
                                }}
                                value={filters.idDelegacion}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'autocomplete_complex',
                                    displayName: 'Pacientes',
                                    name: 'idPaciente',
                                    options: pacientes,
                                    key: `${filters?.idPaciente}-paciente`,
                                    renderOption: renderOption,
                                    filterOptions: filterOptions
                                }}
                                value={filters.idPaciente}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                    </Fragment>
                )}
                {filters?.tipoVisita == 1 && (
                    <Fragment>
                        <Grid size={{ xs: 6, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'select',
                                    displayName: 'Mes',
                                    name: 'mes',
                                    options: mesesEnum.map(x => ({ id: x.code, displayName: x.name }))
                                }}
                                value={filters.mes}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                        <Grid size={{ xs: 6, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'select',
                                    displayName: 'Año',
                                    name: 'anio',
                                    options: getLastYearsList(8).map(year => ({ id: year, displayName: year.toString() }))
                                }}
                                value={filters.anio}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                        <Grid size={{ xs: 6, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    type: 'search',
                                    displayName: 'Buscar',
                                    name: 'textInput',
                                }}
                                value={filters.textInput}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                        <Grid size={{ xs: 6, md: 6, lg: 4, xl: 3 }}>
                            <RenderInputByTypeMobile
                                input={{
                                    displayName: 'Estado',
                                    type: 'select',
                                    name: 'estado',
                                    options: estados
                                }}
                                value={filters.estado}
                                handleChange={handleChangeFilters}
                            />
                        </Grid>
                    </Fragment>
                )}
            </Grid>
        </>
    )
}